import { Link } from "react-router-dom";
import { Reveal } from "@/components/Reveal";

export default function CTABand({ heading, subtext, buttonText = "Request an Estimate", buttonTo = "/contact" }) {
  return (
    <section className="bg-[#043B1C]" data-testid="cta-band">
      <div className="mx-auto max-w-[1160px] px-5 py-16 md:px-8 md:py-24">
        <Reveal>
          <h2 className="max-w-2xl text-3xl font-extrabold leading-[1.15] tracking-tight text-white md:text-[2.6rem]">
            {heading}
          </h2>
          {subtext && (
            <p className="mt-4 max-w-xl text-base leading-[1.6] text-white/70">{subtext}</p>
          )}
          <Link
            to={buttonTo}
            data-testid="cta-band-button"
            className="mt-8 inline-block rounded-full bg-white px-8 py-4 text-sm font-bold text-[#043B1C] transition-colors duration-300 hover:bg-[#F4BE36]"
          >
            {buttonText}
          </Link>
        </Reveal>
      </div>
    </section>
  );
}
